/**
 * i18n altyapısı. Mevcut katalog: tr (tam), en (iskelet).
 * setLocale('en') ile değiştir; eksik anahtarlar dev'de console.warn ile uyarı verir.
 */

import { tr } from './tr';
import { en } from './en';

export const DEFAULT_LOCALE = 'tr';

/** @type {string} */
let currentLocale = DEFAULT_LOCALE;

const catalogs = {
  tr,
  en,
};

/**
 * @param {string} locale
 */
export function setLocale(locale) {
  if (catalogs[locale]) {
    currentLocale = locale;
  }
}

export function getLocale() {
  return currentLocale;
}

/**
 * Nokta ile ayrılmış anahtar: `auth.login.title`, `errors.http.status400`
 * @param {string} key
 * @param {Record<string, string | number>} [vars] — `{ name }` → metinde `{name}` yerine koyar
 * @returns {string}
 */
export function t(key, vars) {
  const parts = key.split('.');
  let cur = catalogs[currentLocale];
  for (const p of parts) {
    if (cur == null || typeof cur !== 'object') {
      cur = undefined;
      break;
    }
    cur = cur[p];
  }
  let out = typeof cur === 'string' ? cur : key;
  if (vars && typeof out === 'string') {
    out = out.replace(/\{(\w+)\}/g, (_, k) =>
      vars[k] !== undefined && vars[k] !== null ? String(vars[k]) : `{${k}}`
    );
  }
  if (out === key && process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn(`[i18n] Eksik anahtar: ${key} (locale=${currentLocale})`);
  }
  return out;
}

export { tr, en };
